function sidebarTemplate(active) {
	return Helper.template.sidebarNav([
		{
			content: `<span class="list-label"><i class="ph ph-tree-structure"></i> Areas Tree</span>`,
			route: "/#!/areas/tree",
			is_active: active == "areas-tree"
		},
		{
			content: `<span class="list-label"><i class="ph ph-play"></i> Actions</span>`,
			route: "/#!/scripts/actions",
			is_active: active == "actions"
		}
	]);
}

export {
	sidebarTemplate
}